import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useLazyQuery,
} from '@apollo/client';
import { IGetAlertMetadata } from './types';

export const GET_ALERT_METADATA_NON_SURICATA_ALERT_TTP = gql`
  query getAlertMetadataNonSuricataAlertTtp($items: [GetAlertMetadataInput]!) {
    getAlertMetadata(items: $items) {
      metadata {
        chatbot_chats {
          non_suri_alert_ttp
        }
      }
    }
  }
`;

export const useGetAlertMetadataNonSuricataAlertTTP = (
  options: QueryHookOptions<IGetAlertMetadata, OperationVariables>,
) =>
  useLazyQuery<IGetAlertMetadata>(
    GET_ALERT_METADATA_NON_SURICATA_ALERT_TTP,
    options,
  );
